import React from "react";
import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  label: {
    fontFamily: 'Roboto-Bold',
    fontSize: 16,
    color: '#202A38'
  },
  asterisk: {
    color: theme.palette.primary.main
  },
}))

const QuestionLabel = ({label, required}) => {
  const classes = useStyles();

  return (
    <span className={classes.label}>
      {label}{required && <span className={classes.asterisk}>&nbsp;*</span>}
    </span>
  )
}

export default QuestionLabel;